import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { Button, Accordion } from "react-bootstrap";
import moment from "moment";

import { Link } from "react-router-dom";
import * as actions from "./_redux/Actions";

import {
  CONTEST_STATUS_BTN,
  CONTEST_STATUS_BORDER,
  CONTEST_STATUS,
  CONTEST_STATUS_BG_TABLE,
  CONTEST_STATUS_TEXT,
  imageUrl,
} from "../../components/UIHelpers";
import helperFunc from "../../../_metronic/_helpers/helperFunc";
import DropdownReactSelect from "../../components/DropdownReactSelect";

import "./ContestList.css";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

export default function GamerjiTournamentSummeryDetailsNew(props) {
  const dispatch = useDispatch();
  const [rules, setRules] = useState({});
  const [canclebox, setCanclebox] = useState(false);
  const [isRound, setIsRound] = useState(false);
  const [isContest, setIsContest] = useState(false);
  const [isFullContest, setIsFullContest] = useState(false);
  const [
    cancelReasonDropdownFilterData,
    setCancelReasonDropdownFilterData,
  ] = useState([]);
  const [
    cancelReasonSelectedDropdownFilterData,
    setCancelReasonSelectedDropdownFilterData,
  ] = useState(null);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.tournamentsSlice }),
    shallowEqual
  );
  const {
    actionsLoading,
    contestUsers,
    listLoading,
    tournamentForEdit,
    rulesFetched,
    tournamentRules,
    bracketsImages,
    tournamentPointPool,
    tournamentPrizePool,
    roundCount,
    totalContest,
    totalFullContest,
    cancelReason,
  } = currentState;

  useEffect(() => {
    console.log("tournamentPointPool", tournamentPointPool);
    // console.log(
    //   "**********************tournamentRules?.rules",
    //   tournamentForEdit?.rules
    // );
    // setRules(tournamentForEdit?.rules);
    // if (
    //   tournamentForEdit?.game?.settings?.cancellationReason &&
    //   tournamentForEdit?.game?.settings.cancellationReason.length > 0
    // ) {
    //   let temp = [];
    //   tournamentForEdit.game.settings.cancellationReason.forEach(
    //     (element, i) => {
    //       temp.push({
    //         _id: i + 1,
    //         label: element,
    //         value: element,
    //       });
    //     }
    //   );
    //   setCancelReasonDropdownFilterData(temp);
    // }
  }, [tournamentForEdit]);
  useEffect(() => {
    console.log("***ules?.rules", tournamentRules);
    setRules(tournamentRules);
    // if (
    //   tournamentForEdit?.game?.settings?.cancellationReason &&
    //   tournamentForEdit?.game?.settings.cancellationReason.length > 0
    // ) {
    //   let temp = [];
    //   tournamentForEdit.game.settings.cancellationReason.forEach(
    //     (element, i) => {
    //       temp.push({
    //         _id: i + 1,
    //         label: element,
    //         value: element,
    //       });
    //     }
    //   );
    //   setCancelReasonDropdownFilterData(temp);
    // }
  }, [tournamentRules]);
  useEffect(() => {
    console.log(cancelReason, "--------------");
    if (
      cancelReason?.settings?.cancellationReason &&
      cancelReason.settings.cancellationReason.length > 0
    ) {
      let temp = [];
      cancelReason.settings.cancellationReason.forEach((element, i) => {
        temp.push({
          _id: i + 1,
          label: element,
          value: element,
        });
      });
      setCancelReasonDropdownFilterData(temp);
    }
  }, [cancelReason]);

  // const CurrencyIcoon = ({ item }) => {
  //   return (
  //     <span className="text-dark-50 font-weight-bold">
  //       {tournamentForEdit?.currency && tournamentForEdit?.currency?.img ? (
  //         <img
  //           className="currency"
  //           src={`${
  //             process.env.REACT_APP_UPLOADED_FILE_URL
  //           }/${tournamentForEdit?.currency &&
  //             tournamentForEdit?.currency?.img?.default}`}
  //           alt="currency"
  //         />
  //       ) : (
  //         <span className="text-dark-50 font-weight-bold">₹</span>
  //       )}
  //     </span>
  //   );
  // };

  // const viewItem = (id) => {
  //   const url = `/${process.env.REACT_APP_PUBLIC_URL_SFIX}tournaments/view/${id}`;
  //   window.open(url, "_blank");
  // };

  // const GetNoOfMatches = (data) => {
  //   let noOfmatches = 0;
  //   data.rounds.forEach((round) => (noOfmatches += round.matches.length));

  //   return noOfmatches;
  // };

  const [isDisabled, setIsDisabled] = useState(false);

  const cancleTournament = () => {
    if (!cancelReasonSelectedDropdownFilterData?.value) {
      NotificationManager.error("Please Select Cancel Reason", "Error");
    } else {
      let payload = {
        _id: tournamentForEdit?._id,
        type: "tournamentCancle",
        cancelReason: cancelReasonSelectedDropdownFilterData?.value,
        cancelTime: moment(),
        status: CONTEST_STATUS.cancelled,
      };
      if (tournamentForEdit?._id) {
        setIsDisabled(true); // Disable the button immediately after clicking
        dispatch(actions.setCompleteStatusByContestId(payload)).then(
          (success) => {
            if (success) {
              reloadLocation();
            } else {
              setIsDisabled(false); // Re-enable the button if the API call fails
            }
          }
        );
      }
    }
  };

  const reloadLocation = () => {
    // console.log("first weeeeeeeeeeeeeS")
    window.location.reload();
  };

  const viewTotalRound = (id) => {
    setIsRound(true);
    dispatch(actions.getTournamentRoundCount(id));
  };
  const viewTotalContest = (id) => {
    setIsContest(true);
    dispatch(actions.getTournamentContestCount(id));
  };
  const viewTotalFullContest = (id) => {
    setIsFullContest(true);
    dispatch(actions.getTournamentFullContestCount(id));
  };
  const getCancellationReason = (id) => {
    setCanclebox(true);
    dispatch(actions.getTournamentCancellationReason(id));
  };
  const handleToggleClick = (_id) => {
    const storedId = localStorage.getItem("tournamentId");
    const tournamentId = storedId || _id; // Use the storedId if available, otherwise use the passed id
    dispatch(actions.fetchTournamentRules(tournamentId));
  };

  const handleToggleClickPool = (id) => {
    // const storedId = localStorage.getItem("tournamentId");
    // const tournamentId = storedId || id; // Use the storedId if available, otherwise use the passed id
    dispatch(actions.fetchTournamentPrizePool(id));
  };
  const handleToggleClickPoint = (id) => {
    // const storedId = localStorage.getItem("tournamentId");
    // const tournamentId = storedId || id; // Use the storedId if available, otherwise use the passed id
    dispatch(actions.fetchTournamentPointPool(id));
  };
  return (
    <div className="">
      <NotificationContainer />
      <div className="row">
        <div className="col-md-12">
          <div
            className={`card border-1 border-warning card-custom gutter-b mb-12 ${
              CONTEST_STATUS_BORDER[tournamentForEdit.status]
            }`}
          >
            <div className="card-body">
              <div className="contest-title">
                {tournamentForEdit.title ||
                  (tournamentForEdit.contestType &&
                    tournamentForEdit.contestType.name)}
              </div>
              {/* begin::Top */}
              <div className="d-flex">
                {/* <!--begin::Pic--> */}
                <div className="flex-shrink-0 mr-7">
                  <div className="symbol symbol-50 symbol-lg-120">
                    <img
                      alt="Pic"
                      src={imageUrl(tournamentForEdit &&
                        tournamentForEdit.featuredImage &&
                        tournamentForEdit.featuredImage.default)}
                    />
                  
                  </div>
                </div>
                {/* <!--end::Pic--> */}
                {/* <!--begin: Info--> */}
                <div className="flex-grow-1">
                  {/* <!--begin::Title--> */}
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    {/* <!--begin::User--> */}
                    <div className="mr-3" style={{ width: "90%" }}>
                      {/* <!--begin::Name--> */}
                      <div
                        to={"#"}
                        className="d-flex align-items-center text-dark text-hover-primary font-size-h5 font-weight-bold mr-3"
                      >
                        {tournamentForEdit.game && tournamentForEdit.game.name}{" "}
                        -{" "}
                        {tournamentForEdit.gameType &&
                          tournamentForEdit.gameType.name}
                        <i className="flaticon2-correct text-success icon-md ml-2"></i>
                      </div>
                    </div>
                    {/* <!--end::User--> */}
                    {/* <!--begin::Actions--> */}
                    <div className="my-lg-0 my-1"></div>
                    {/* <!--end::Actions--> */}
                  </div>
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex flex-wrap my-2 text-muted text-hover-primary font-weight-bold">
                      <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                        <i className="flaticon2-calendar-1"></i>
                      </span>{" "}
                      {moment(tournamentForEdit.startDate).format("ll")} -{" "}
                      {moment(tournamentForEdit.endDate).format("ll")}
                    </div>
                    <div className="d-flex align-items-end flex-wrap justify-content-end">
                      <div className="d-flex mt-4 mt-sm-0">
                        <div
                          to={"#"}
                          className={`btn-sm w-120px btn mb-lg-0 mb-2 text-uppercase ${
                            CONTEST_STATUS_BG_TABLE[tournamentForEdit.status]
                          } ${CONTEST_STATUS_TEXT[tournamentForEdit.status]}`}
                        >
                          {/* CONTEST_STATUS_TEXT */}
                          {tournamentForEdit.status}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!--end::Title--> */}
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex flex-wrap my-2">
                      <div className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2">
                        <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                          ShortCode :
                        </span>{" "}
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            try {
                              navigator.clipboard.writeText(
                                tournamentForEdit.shortCode
                              );
                              NotificationManager.success(
                                "Shortcode copied",
                                "Success"
                              );
                            } catch (err) {
                              console.error("Failed to copy: ", err);
                            }
                          }}
                        >
                          {tournamentForEdit.shortCode || null}
                        </span>
                      </div>
                      <div
                        to={"#"}
                        className="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2"
                      >
                        <span className="svg-icon svg-icon-md svg-icon-gray-500 mr-1">
                          Id :
                        </span>{" "}
                        {tournamentForEdit._id}
                      </div>
                    </div>
                    {/* <!--begin::Progress--> */}
                    <div className="d-flex align-items-center flex-wrap justify-content-between">
                      {(tournamentForEdit?.isMinimumEnable===true)?(
                        <div className="mt-4 mt-sm-0">
                          {/* {console.log('tournamentForEdit', tournamentForEdit.isMinimumEnable, tournamentForEdit.minimumSlot)} */}
                          <div className="progress progress-xs mt-2 mb-2 flex-shrink-0 w-xl-250px">
                            <div
                              className="progress-bar bg-success"
                              role="progressbar"
                              style={{
                                width: `${parseInt(
                                  tournamentForEdit.totalJoinedPlayers * 100
                                ) / parseInt(tournamentForEdit.totalPlayers)}%`,
                              }}
                              aria-valuenow="50"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                            <div
                              className="progress-bar"
                              role="progressbar"
                              style={{
                                width: `${parseInt(
                                  (tournamentForEdit.minimumSlot <= tournamentForEdit.totalJoinedPlayers) ?
                                   0 * 100 :
                                  (tournamentForEdit.minimumSlot - (tournamentForEdit.totalJoinedPlayers)) * 100) / parseInt(tournamentForEdit.totalPlayers)}%`,
                                backgroundColor: "#979797"
                              }}
                              aria-valuenow="50"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>

                          </div>
                          <span className="font-weight-bold font-size-sm mr-4">
                            {tournamentForEdit.totalJoinedPlayers || 0} Joined
                            User
                          </span>
                          <span className="font-weight-bold font-size-sm mr-4">
                            {tournamentForEdit.minimumSlot || 0} Minimum slot
                          </span>
                          <span className="font-weight-bold font-size-sm ml-4">
                            {parseInt(tournamentForEdit.totalPlayers) -
                              parseInt(tournamentForEdit.totalJoinedPlayers) ||
                              0}{" "}
                            Remaining users
                          </span>
                        </div>
                      ):(
                          <div className = "mt-4 mt-sm-0">
                        <div className = "progress progress-xs mt-2 mb-2 flex-shrink-0 w-xl-250px">
                          <div
                            className = "progress-bar bg-success"
                            role = "progressbar"
                            style = {{
                            width: `${parseInt(
                              tournamentForEdit.totalJoinedPlayers * 100
                              ) / parseInt(tournamentForEdit.totalPlayers)}%`,
                            }}
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                          ></div>
                  </div>
                  <span className="font-weight-bold font-size-sm mr-4">
                    {tournamentForEdit.totalJoinedPlayers || 0} Joined
                    User
                  </span>
                  <span className="font-weight-bold font-size-sm ml-4">
                    {parseInt(tournamentForEdit.totalPlayers) -
                      parseInt(tournamentForEdit.totalJoinedPlayers) ||
                      0}{" "}
                    Remaining users
                  </span>
                </div>
                      )}
                      
                    </div>
                    {/* <!--end::Progress--> */}
                  </div>
                </div>
                {/* <!--end: Info--> */}
              </div>
              {/* end::Top */}

              {/* <!--begin::Separator--> */}
              <div className="separator separator-solid my-5"></div>
              {/* <!--end::Separator--> */}
              {/* <!--begin::Bottom--> */}
              <div className="d-flex align-items-center flex-wrap">
                {/* <!--begin: Item--> */}

                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                    <i className="flaticon-file-2 icon-2x text-muted font-weight-bold"></i>
                  </span>
                  <div className="d-flex flex-column flex-lg-fill">
                    <span className="text-muted font-weight-bolder font-size-sm">
                      Total Rounds
                    </span>
                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                      {!isRound ? (
                        <a
                          className="btn btn-icon btn-light btn-text-primary btn-sm mr-2"
                          title="View"
                          onClick={() => {
                            viewTotalRound(tournamentForEdit._id);
                          }}
                        >
                          <span className="svg-icon svg-icon-md">
                            <svg
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xlink="http://www.w3.org/1999/xlink"
                            >
                              {/* <title>
                              Stockholm-icons / General / Visible
                            </title> */}
                              <desc>Created with Sketch.</desc>
                              <defs></defs>
                              <g
                                id="Stockholm-icons-/-General-/-Visible"
                                stroke="none"
                                strokeWidth="1"
                                fill="none"
                                fillRule="evenodd"
                              >
                                <rect
                                  id="bound"
                                  x="0"
                                  y="0"
                                  width="24"
                                  height="24"
                                ></rect>
                                <path
                                  d="M3,12 C3,12 5.45454545,6 12,6 C16.9090909,6 21,12 21,12 C21,12 16.9090909,18 12,18 C5.45454545,18 3,12 3,12 Z"
                                  id="Shape"
                                  fill="#000000"
                                  fillRule="nonzero"
                                ></path>
                                <path
                                  d="M12,15 C10.3431458,15 9,13.6568542 9,12 C9,10.3431458 10.3431458,9 12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 Z"
                                  id="Path"
                                  fill="#000000"
                                  opacity="0.3"
                                ></path>
                              </g>
                            </svg>
                          </span>
                        </a>
                      ) : (
                        roundCount
                      )}
                    </span>
                  </div>
                </div>
                {/* <!--end: Item--> */}
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                    <i className="flaticon-file-2 icon-2x text-muted font-weight-bold"></i>
                  </span>
                  <div className="d-flex flex-column flex-lg-fill">
                    <span className="text-muted font-weight-bolder font-size-sm">
                      Total Contests
                    </span>
                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                      {!isContest ? (
                        <a
                          className="btn btn-icon btn-light btn-text-primary btn-sm mr-2"
                          title="View"
                          onClick={() => {
                            viewTotalContest(tournamentForEdit._id);
                          }}
                        >
                          <span className="svg-icon svg-icon-md">
                            <svg
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xlink="http://www.w3.org/1999/xlink"
                            >
                              {/* <title>
                                Stockholm-icons / General / Visible
                              </title> */}
                              <desc>Created with Sketch.</desc>
                              <defs></defs>
                              <g
                                id="Stockholm-icons-/-General-/-Visible"
                                stroke="none"
                                strokeWidth="1"
                                fill="none"
                                fillRule="evenodd"
                              >
                                <rect
                                  id="bound"
                                  x="0"
                                  y="0"
                                  width="24"
                                  height="24"
                                ></rect>
                                <path
                                  d="M3,12 C3,12 5.45454545,6 12,6 C16.9090909,6 21,12 21,12 C21,12 16.9090909,18 12,18 C5.45454545,18 3,12 3,12 Z"
                                  id="Shape"
                                  fill="#000000"
                                  fillRule="nonzero"
                                ></path>
                                <path
                                  d="M12,15 C10.3431458,15 9,13.6568542 9,12 C9,10.3431458 10.3431458,9 12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 Z"
                                  id="Path"
                                  fill="#000000"
                                  opacity="0.3"
                                ></path>
                              </g>
                            </svg>
                          </span>
                        </a>
                      ) : (
                        totalContest
                      )}
                      {/* {<GetNoOfMatches rounds={tournamentForEdit.rounds} />} */}
                    </span>
                  </div>
                </div>
                {/* <!--end: Item--> */}
                {/* <!--begin: Item--> */}
                <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                  <span className="mr-4">
                    <i className="flaticon-file-2 icon-2x text-muted font-weight-bold"></i>
                  </span>
                  <div className="d-flex flex-column flex-lg-fill">
                    <span className="text-muted font-weight-bolder font-size-sm">
                      No of Full contest
                    </span>
                    <span className="font-weight-bolder font-size-h5 text-dark-75">
                      {!isFullContest ? (
                        <a
                          className="btn btn-icon btn-light btn-text-primary btn-sm mr-2"
                          title="View"
                          onClick={() => {
                            viewTotalFullContest(tournamentForEdit._id);
                          }}
                        >
                          <span className="svg-icon svg-icon-md">
                            <svg
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xlink="http://www.w3.org/1999/xlink"
                            >
                              {/* <title>
                                Stockholm-icons / General / Visible
                              </title> */}
                              <desc>Created with Sketch.</desc>
                              <defs></defs>
                              <g
                                id="Stockholm-icons-/-General-/-Visible"
                                stroke="none"
                                strokeWidth="1"
                                fill="none"
                                fillRule="evenodd"
                              >
                                <rect
                                  id="bound"
                                  x="0"
                                  y="0"
                                  width="24"
                                  height="24"
                                ></rect>
                                <path
                                  d="M3,12 C3,12 5.45454545,6 12,6 C16.9090909,6 21,12 21,12 C21,12 16.9090909,18 12,18 C5.45454545,18 3,12 3,12 Z"
                                  id="Shape"
                                  fill="#000000"
                                  fillRule="nonzero"
                                ></path>
                                <path
                                  d="M12,15 C10.3431458,15 9,13.6568542 9,12 C9,10.3431458 10.3431458,9 12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 Z"
                                  id="Path"
                                  fill="#000000"
                                  opacity="0.3"
                                ></path>
                              </g>
                            </svg>
                          </span>
                        </a>
                      ) : (
                        totalFullContest
                      )}
                      {/* {tournamentForEdit.contestFull} */}
                    </span>
                  </div>
                </div>
                {/* <!--end: Item--> */}
                {/* <!--begin: Item--> */}
                {tournamentForEdit.winningTerm && (
                  <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                    <span className="mr-4">
                      <i className="flaticon-file-2 icon-2x text-muted font-weight-bold"></i>
                    </span>
                    <div className="d-flex flex-column flex-lg-fill">
                      <span className="text-muted font-weight-bolder font-size-sm">
                        Winning Term
                      </span>
                      <span className="font-weight-bolder font-size-h5 text-dark-75">
                        {tournamentForEdit.winningTerm}
                      </span>
                    </div>
                  </div>
                )}
                {tournamentForEdit.status !== "cancelled" &&
                  tournamentForEdit.status !== "completed" && (
                    <div className="d-flex align-items-center flex-lg-fill mr-5 my-1">
                      <div className="d-flex flex-column flex-lg-fill">
                        {helperFunc.isButtonAccess(
                          "tournament.closeTournaments.delete"
                        ) && (
                          <button
                            type="button"
                            onClick={() =>
                              getCancellationReason(tournamentForEdit.game._id)
                            }
                            className="btn mt-20m btn-danger"
                          >
                            Cancel
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                {/* <!--end: Item--> */}
              </div>
              {/* <!--end::Bottom--> */}
            </div>
            {tournamentForEdit.status === "cancelled" && (
              <div className="bg-danger card-footer p-4">
                <div className="cancle-reason text-white">
                  {tournamentForEdit.cancelReason}{" "}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {canclebox && tournamentForEdit.status !== "cancelled" && (
        <Card>
          <CardHeader title={"Tournament Cancle"}></CardHeader>
          <CardBody>
            <div className="row">
              <div className="col-md-4 pb-5">
                <lable className="d-block h5 mb-1 pb-5">Select Reason</lable>
                <DropdownReactSelect
                  placeholder={"Select..."}
                  name={"cancelReason"}
                  value={cancelReasonSelectedDropdownFilterData}
                  isMulti={false}
                  isClearable={true}
                  isSearchable={true}
                  closeMenuOnSelect={true}
                  options={cancelReasonDropdownFilterData}
                  onChange={setCancelReasonSelectedDropdownFilterData}
                />
              </div>
              <div className="col-md-8">
                <button
                  type="button"
                  onClick={() => cancleTournament()}
                  className="btn mt-11 btn-primary"
                  disabled={isDisabled}
                >
                  Cancel Tournament
                </button>
                <button
                  type="button"
                  onClick={() => setCanclebox(!canclebox)}
                  className="btn mt-11 btn-success ml-3"
                >
                  Close
                </button>
              </div>
            </div>
          </CardBody>
        </Card>
      )}
      <div className="col-md-12 mb-10 p-0">
        <Accordion>
          <Card>
            <Accordion.Toggle
              as={Button}
              variant="link"
              eventKey="0"
              onClick={() => handleToggleClickPool(tournamentForEdit._id)}
            >
              <CardHeader title={"Prize Pool Info"}></CardHeader>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="0">
              <CardBody>
                {tournamentPrizePool?.prizePooInfo &&
                tournamentPrizePool.prizePooInfo.length > 0 ? (
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>RANK FROM</th>
                        <th>RANK TO</th>
                        <th>AMOUNT</th>
                        <th>TOTAL AMOUNT</th>
                        <th>WINNING PRIZE</th>
                      </tr>
                    </thead>
                    <tbody>
                      {console.log(
                        "fjdsfdbfvdj",
                        tournamentPrizePool?.prizePoolType
                      )}
                      {tournamentPrizePool.prizePooInfo.length > 0 &&
                        tournamentPrizePool.prizePooInfo.map((data, indp) => (
                          <tr key={"indp" + indp}>
                            <td>{indp + 1}</td>
                            <td>{data.rankFrom}</td>
                            <td>{data.rankTo || 0}</td>
                            <td>
                              {" "}
                              {tournamentPrizePool?.prizePoolType === "rewards"
                                ? "N/A"
                                : data.amount}
                            </td>
                            <td>
                              {tournamentPrizePool?.prizePoolType === "rewards"
                                ? "N/A"
                                : data.totalAmount}
                            </td>
                            <td>
                              {" "}
                              {tournamentPrizePool?.prizePoolType === "rewards"
                                ? data.prize
                                : "N/A"}
                            </td>
                            {/* console.log("djbhfd", ) */}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                ) : (
                  <p style={{ fontWeight: "500", lineHeight: "1.2" }}>
                    No Records Found
                  </p>
                )}
              </CardBody>
            </Accordion.Collapse>
          </Card>

          <Card>
            <Accordion.Toggle
              as={Button}
              variant="link"
              eventKey="2"
              onClick={() => handleToggleClickPoint(tournamentForEdit._id)}
            >
              <CardHeader title={"Point Pool Info"}></CardHeader>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="2">
              <CardBody>
                {tournamentPointPool?.pointpool &&
                tournamentPointPool.pointpool.length > 0 ? (
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>RANK FROM</th>
                        <th>RANK TO</th>
                        <th>POINTS</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tournamentPointPool.pointpool.map((data, indp) => (
                        <tr key={"rankPointtab" + indp}>
                          <td>{indp + 1}</td>
                          <td>{data.rankFrom}</td>
                          <td>{data.rankTo}</td>
                          <td>{data.point}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <p style={{ fontWeight: "500", lineHeight: "1.2" }}>
                    No Records Found
                  </p>
                )}
              </CardBody>
            </Accordion.Collapse>
          </Card>

          {tournamentForEdit?.eventReportissue &&
            tournamentForEdit.eventReportissue.length > 0 && (
              <Card>
                <Accordion.Toggle as={Button} variant="link" eventKey="3">
                  <CardHeader title={"Reported Issue"}></CardHeader>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="3">
                  <CardBody>
                    <table className="table table-striped table-bordered zero -configuration">
                      <thead>
                        <tr>
                          <th>Sr No</th>
                          <th>Issue</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tournamentForEdit.eventReportissue.map(
                          (issue, ind) => (
                            <tr key={`issue-key${ind}`}>
                              <th>{ind + 1}</th>
                              <th>{issue.reportIssue.issue}</th>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </CardBody>
                </Accordion.Collapse>
              </Card>
            )}

          <Card>
            <Accordion.Toggle
              as={Button}
              variant="link"
              eventKey="1"
              onClick={() => handleToggleClick("1")}
            >
              <CardHeader title={"Rules"}></CardHeader>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey="1">
              <CardBody>
                {tournamentRules &&
                  tournamentRules.map((tournament, index) => (
                    <div key={index}>
                      <h4 className="mb-10 font-weight-bold text-dark">
                        {tournament.company_id} Rules
                      </h4>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: tournament.rules,
                        }}
                      />
                    </div>
                  ))}
              </CardBody>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
    </div>
  );
}
